export default {"src":"/_next/static/media/okx-wallet.b8dfe385.svg","height":1000,"width":1000,"blurWidth":0,"blurHeight":0};